import { LuCheck, LuClock, LuTriangleAlert } from "react-icons/lu";

export const LicenseStatuses = {
   'ACTIVE': { name: 'Ativo', color: 'var(--color-green-400)' },
   'INACTIVE': { name: 'Inativo', color: 'var(--color-gray-400)' },
   'BLOCKED': { name: 'Bloqueado', color: 'var(--color-purple-400)' },
}

export const LicenseTypes = [
   'PRD0028',
   'PRD0025',
   'PRD0023',
];

export const LicenseBillingStatus = {
   PAID: 'PAID',
   PENDING: 'PENDING',
   OVERDUE: 'OVERDUE',
   EXPIRING: 'EXPIRING',
}

export const LicensesBillingStatuses = {
   [LicenseBillingStatus.PAID]: { icon: LuCheck, name: 'Pago', descriptive: 'Pagamento em dia', color: 'var(--activeLicensesColor)' },
   [LicenseBillingStatus.PENDING]: { icon: LuClock, name: 'Pendente', color: 'var(--pendingLicensesColor)' },
   [LicenseBillingStatus.OVERDUE]: { icon: LuTriangleAlert, name: 'Em atraso', color: 'var(--expiredLicensesColor)' },
   [LicenseBillingStatus.EXPIRING]: { icon: LuClock, name: 'Vencendo', color: 'var(--upcomingDueLicensesColor)' }
}

export function pickRandomStatus() {
   const entries = Object.entries(LicenseStatuses);
   return LicenseStatuses[entries[Math.floor(Math.random() * entries.length)][0]];
}

export function pickRandomType() {
   const entries = Object.entries(LicenseTypes);
   return LicenseTypes[entries[Math.floor(Math.random() * entries.length)][0]];
}